export const formatDuration = (durationInSeconds: number): string => {
  return [
    Math.floor(durationInSeconds / 60),
    `0${Math.round(durationInSeconds % 60)}`.slice(-2),
  ].join(":");
};
